import { render, staticRenderFns } from "./signature-pad.vue?vue&type=template&id=bc09a534&scoped=true"
import script from "./signature-pad.vue?vue&type=script&lang=js"
export * from "./signature-pad.vue?vue&type=script&lang=js"
import style0 from "./signature-pad.vue?vue&type=style&index=0&id=bc09a534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc09a534",
  null
  
)

export default component.exports